import { Link, useSearchParams } from "react-router-dom";
import "../App.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import { APP_ROUTES } from "../constants/appRoutes";
import AuthLayout from "./auth/AuthLayout";
import ActivateForm from "./auth/ActivateForm";

const ActivateAccount = () => {
    const [searchParams] = useSearchParams();
    const email = searchParams.get("email") || "";

    return (
        <AuthLayout>
            <h1 className="mb-2 text-center text-xl font-bold text-slate-900">Activate your account</h1>
            <p className="mb-6 text-center text-sm text-slate-600">
                Check your email for a 6-digit activation code (expires in 10 minutes).
            </p>

            <ActivateForm email={email} />

            <p className="mt-5 text-center text-sm text-slate-600">
                <Link className="font-semibold text-slate-900 hover:text-slate-700" to={APP_ROUTES.HOME}>
                    Back to home
                </Link>
            </p>
        </AuthLayout>
    );
};

export default ActivateAccount;
